import logger from '../../libs/logger/Logger';

type WakeLockState = {
  lock: WakeLockSentinel | null;
  isActive: boolean;
};

const wakeLockState: WakeLockState = {
  lock: null,
  isActive: false,
};

export async function setupWakeLock() {
  if (wakeLockState.isActive) {
    return;
  }

  try {
    if ('wakeLock' in navigator) {
      wakeLockState.isActive = true;

      const lock = await navigator.wakeLock.request('screen');

      lock.addEventListener('release', () => {
        logger.log('Wake lock has been released');
        wakeLockState.isActive = false;
      });

      wakeLockState.lock = lock;

      logger.log('Wake lock has been acquired');
    } else {
      logger.warn('Wake Lock API not supported in this browser');
    }
  } catch (error) {
    wakeLockState.isActive = false;
  }
}

export async function releaseWakeLock() {
  if (!wakeLockState.isActive || !wakeLockState.lock) {
    return;
  }

  try {
    wakeLockState.isActive = false;

    await wakeLockState.lock.release();

    wakeLockState.lock = null;

    logger.log('Wake lock released successfully');
  } catch (error) {
    logger.error(`Failed to release wake lock: ${error}`);
  }
}
